import React, { useState, useRef, useEffect } from "react";
import {
	Avatar,
	Box,
	Button,
	IconButton,
	Popover,
	Stack,
	TextField,
	Typography,
	Divider,
	List,
	ListItem,
	ListItemText,
	ListItemButton,
	Paper,
	Menu,
	MenuItem,
	Tooltip,
} from "@mui/material";
import { Send, Delete, Reply } from "@mui/icons-material";
import { AuthState } from "context/AuthContext";
import { fastapiVmInstance } from "utils/AxiosInstances/RareboxFastApi";
import { GlobalState } from "context/GlobalContext";
import { ReportsState, useWebSocketOpen } from "context/ReportsContext";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from '@mui/icons-material/Image';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';

import dayjs from "dayjs";
import { get } from "lodash";
import { el } from "date-fns/locale";


 const formatMessageTime = (timestamp) => {
  const date = dayjs(timestamp);
  const now = dayjs();

  if (date.isSame(now, "day")) return date.format("h:mm A");
  if (date.isSame(now.subtract(1, "day"), "day")) return `Yesterday, ${date.format("h:mm A")}`;
  if (date.isAfter(now.subtract(7, "day"))) return date.format("ddd, h:mm A");
  return date.format("MMM D, YYYY, h:mm A");
}

// ✅ Shared wrapper style for all previews
	const wrapperStyle = {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
		width: "100%",
		height: "100%",
		overflow: "hidden",
		textAlign: "center",
	};

	const CommonTooltip = ({title}) =>{
		return <Tooltip title={title} arrow>
				<Typography variant="caption" noWrap sx={{ maxWidth: "80px", mt: 0.5, margin: "3px" }}>
					{title}
				</Typography>
			</Tooltip>
	}

	const getFileIcons = (fileType) =>{
		console.log("fileType",fileType)
		if (["jpeg", "png", "jpg", "gif", "bmp", "webp"].includes(fileType)) {
			return <ImageIcon color="primary" sx={{ fontSize: 50 }} />
		}
		else if (fileType === "pdf") {
			return <PictureAsPdfIcon color="error" sx={{ fontSize: 50 }} />
		}
		else if (["xls", "xlsx", "csv"].includes(fileType)
		) {
			return <DescriptionIcon color="success" sx={{ fontSize: 50 }} />
		}
		else if (["txt"].includes(fileType)
		) {
			return <TextSnippetIcon color="success" sx={{ fontSize: 50 }} />
		}
		else {
			return <InsertDriveFileIcon color="action" sx={{ fontSize: 50 }} />
		}
	}

export default function NotesSetion() {
	const [newComment, setNewComment] = useState("");
	const [anchorEl, setAnchorEl] = useState(null);
	const [replyTo, setReplyTo] = useState(null);
	const {user} = AuthState();
	const [mentionList, setMentionList] = useState([]);
	const open = Boolean(anchorEl);
	const { setSnackBarOpen, setSnackBar, snackBar, LoadingOpen, setLoadingOpen, getAppCache, addToAppCache } = GlobalState();
	const { socket, setSocket, comments, setComments, allUsers, setAllUsers, service } = ReportsState();
	const { checkConnection } = useWebSocketOpen();
	const [attachments, setAttachments] = useState([]);

	const chatRef = useRef(null);
	const fileInputRef = useRef(null);

	const ITEM_HEIGHT = 48;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMentionSelect = (user) => {
    setNewComment((prev) => prev + user?.name + ", ");
	setMentionList([...mentionList, user]);
	handleClose()
  };

  const handleRemoveFile = (index) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    // console.log("handleFileChange", files)
	// Only keep valid File or Blob objects
  const validFiles = files.filter(
    (f) => f instanceof File || f instanceof Blob
  );
    setAttachments((prev) => [...prev, ...validFiles]);
  };
  const getComments = async () =>{
	try {
			setLoadingOpen(true);
			await fastapiVmInstance({
				url: `/api/notes/get_notes?report_name=${service.key}`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "GET",
			}).then((res) => {
				console.log("getComments", res.data);
				const result = res?.data?.result || []
				result.forEach(element => {
					element.attachments = JSON.parse(element?.attachments)
				});
				// console.log("getComments1", result)
				setComments(result)
				
			});
		} catch (error) {
			console.log("handle user", error)
		}
		setLoadingOpen(false);
  }


  const handleGetUses = async () => {
		try {
			await fastapiVmInstance({
				url: `/api/notes/users`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "GET",
			}).then((res) => {
				console.log("get_notes_users", res.data);
				setAllUsers(res?.data?.result?.filter((u) => u.email !== user?.email))
				// setLoadingOpen(false);
			});
		} catch (error) {
			console.log("handle user", error)
		}
	};

  const handlePostNotes = async (body) => {
	setLoadingOpen(true);
	console.log("body", body)
	socket.send(JSON.stringify(body));
	};
	// auto scroll to bottom when new comment is added
	useEffect(() => {
		if (chatRef.current) {
			chatRef.current.scrollTop = chatRef.current.scrollHeight;
		}
	}, [comments]);
	useEffect(() => {
		handleGetUses();
		getComments();
	}, []);

	// Utility to convert File → Base64
	const toBase64 = (file) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});

	const handleSendComment = async () => {
		if (!newComment.trim() && attachments.length == 0) return;
		const attachmentsData = await Promise.all(
			attachments.map(async (file) => {
			const base64 = await toBase64(file);
			return {
				name: file.name,
				type: file.type,
				size: file.size,
				data: base64, // base64 encoded string
			};
			})
		);
		const comment = {
			"action": "notify",
			"sender_id": user?.email,
			"receiver_id": mentionList,
			"report_name": service.key,
			"graph_name": '',
			"attachments": attachmentsData || [],
			"message": newComment,
		};
		// console.log("attachmentsData", comment)

		if (!checkConnection(socket)) return
		handlePostNotes(comment);
		setNewComment("");
		setMentionList([]);
		setAttachments([]);
	};

	const handleDelete = (id, parentId = null) => {
		if (parentId) {
			setComments((prev) => prev.map((c) => (c.id === parentId ? { ...c, replies: c.replies.filter((r) => r.id !== id) } : c)));
		} else {
			setComments((prev) => prev.filter((c) => c.id !== id));
		}
	};

	const getFilePreview = (file) => {
		if (!(file instanceof File || file instanceof Blob)) {
			console.warn("Invalid file:", file);
			return null;
		}

		const objectUrl = URL.createObjectURL(file);
		

		// Open file in a new tab when clicked
		const handleOpenFile = () => {
			const newTab = window.open();
			newTab.location.href = objectUrl;
		};

		if (file.type.startsWith("image/")) {
			return (
			<img
				src={objectUrl}
				alt={file.name}
				width="80"
				height="80"
				style={{
				objectFit: "cover",
				borderRadius: 8,
				cursor: "pointer",
				}}
				onClick={handleOpenFile}
				onLoad={() => URL.revokeObjectURL(objectUrl)}
			/>
			);
		} else if (file.type === "application/pdf") {
			return (
			<Box
				onClick={handleOpenFile}
				sx={wrapperStyle}
			>
				{/* <PictureAsPdfIcon color="error" sx={{ fontSize: 50 }} />
				 */}
				 {getFileIcons(file.name.split('.').pop())}
				<CommonTooltip title={file.name}/>
			</Box>
			);
		} else if (
			file.type.includes("spreadsheet") ||
			file.name.endsWith(".xls") ||
			file.name.endsWith(".xlsx") ||
			file.name.endsWith(".csv") 
		) {
			return (
			<Box
				onClick={handleOpenFile}
				sx={wrapperStyle}
			>
				{/* <DescriptionIcon color="success" sx={{ fontSize: 50 }} /> */}
				{getFileIcons(file.name.split('.').pop())}
				<CommonTooltip title={file.name}/>
			</Box>
			);
		} else {
			return (
			<Box
				onClick={handleOpenFile}
				sx={wrapperStyle}
			>
				{/* <InsertDriveFileIcon color="action" sx={{ fontSize: 50 }} /> */}
				{getFileIcons(file.name.split('.').pop())}
				<CommonTooltip title={file.name}/>
			</Box>
			);
		}
		};

	
	const handleReply = (e) => {
		const value = e.target.value;
		setNewComment(value)

		if (value.endsWith("@")) {
      handleMentionClick(e);
	}
};
const handleMentionClick = (event) => {
	setAnchorEl(event.currentTarget);
	
}

const handleOpenFile =async (file) =>{
	// console.log("handleOpenFile", file)
	try {
			await fastapiVmInstance({
				url: `/api/notes/get_surl`,
				data: file,
				headers: {
					"Content-Type": "application/json",
				},
				method: "POST",
			}).then((res) => {
				console.log("get_notes_users", res.data);
				const file = res?.data?.result?.url
				console.log("get_notes_users1", file)
				window.open(file, "_blank");
			});
		} catch (error) {
			console.log("handle user", error)
		}
}

	const handleSelectUser = (user) => {
		setNewComment((prev) => prev + user + " ");
		setAnchorEl(null);
	};

	console.log("comments",attachments)
	return (
		<Box
			sx={{
				height: "80vh",
				width: "95%",
				margin: "auto",
				mx: "auto",
				my: 2,
				// border: "1px solid #ddd",
				borderRadius: 2,
				display: "flex",
				flexDirection: "column",
			}}>
			{/* Comments area */}
			<Box
				ref={chatRef}
				sx={{
					flex: 1,
					overflowY: "auto",
					p: 2,
					bgcolor: "#fafafa",
					maxHeight: "70vh",
				}}>
				{comments.length === 0 ? (
					<Typography color="text.secondary">No Notes yet...</Typography>
				) : (
					<Stack spacing={2}>
						{comments.map((c) => {
							if (user?.email === c.sender_id) {
							return (
								<CommentItem key={`${c.id}_${c.message}`} comment={c} showAvt={false} showName={false} onDelete={()=>{}} onReply={()=>{}} handleOpenFile = { handleOpenFile} />
						)}
							else {
							return <CommentItem key={c.id} comment={c} onDelete={null} onReply={null} handleOpenFile = {handleOpenFile} />}
})}
					</Stack>
				)}
			</Box>

			{/* Fixed input at bottom */}
			<Box sx={{ p: 1, bgcolor: "white" }}>
				{attachments.length > 0 && (
					<Stack
					direction="row"
					spacing={2}
					sx={{
						mb: 1,
						p: 1,
						overflowX: "auto",
						border: "1px solid #ddd",
						borderRadius: 2,
						maxWidth: "100%",
					}}
					>
					{attachments.map((file, index) => (
						<Box
						key={index}
						sx={{
							position: "relative",
							width: 90,
							minWidth: 90,
							height: 90,
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							border: "1px solid #ccc",
							borderRadius: 2,
							bgcolor: "#f9f9f9",
						}}
						>
						{getFilePreview(file)}
						<IconButton
							size="small"
							onClick={() => handleRemoveFile(index)}
							sx={{
							position: "absolute",
							top: 0,
							right: 0,
							bgcolor: "rgba(255,255,255,0.8)",
							}}
						>
							<CloseIcon fontSize="small" />
						</IconButton>
						</Box>
					))}
					</Stack>
				)}
				<Stack direction="row" spacing={2} alignItems="flex-start">
					{/* <Avatar>You</Avatar> */}
					<Box flex={1}>
						<Stack display={"flex"} flexDirection={"row"} alignItems={"center"}>
							<AttachFileIcon onClick={() => fileInputRef.current.click()} sx={{cursor: "pointer"}} />
							<input
								type="file"
								multiple
								ref={fileInputRef}
								onChange={handleFileChange}
								style={{ display: "none" }}
							/>
							<TextField
								multiline
								aria-label="more"
								aria-controls={open ? 'long-menu' : undefined}
								aria-expanded={open ? 'true' : undefined}
								aria-haspopup="true"
								minRows={1}
								fullWidth
								placeholder={replyTo ? "Replying to a Note..." : "Add a Note..."}
								value={newComment}
								onChange={handleReply}
								sx={{
									"& textarea": {
									overflowY: "auto !important",
									maxHeight: 100,
									},
								}}
								// onKeyUpCapture={(e) => {
								// 	if (e.key === "@") handleMentionClick(e);
								// }}
							/>
						</Stack>
						<Menu
							id="long-menu"
							anchorEl={anchorEl}
							open={open}
							onClose={handleClose}
							slotProps={{
							paper: {
								style: {
								maxHeight: ITEM_HEIGHT * 4.5,
								width: '20ch',
								},
							},
							list: {
								'aria-labelledby': 'long-button',
							},
							}}
							anchorOrigin={{
								vertical: 'top',       // attach menu to top of anchor
								horizontal: 'left',
							}}
							transformOrigin={{
								vertical: 'bottom',    // make menu expand upward
								horizontal: 'left',
							}}
						>
							{allUsers.map((option) => (
							<MenuItem key={option} onClick={() => handleMentionSelect(option)}>
								{option?.name}
							</MenuItem>
							))}
						</Menu>
				
						<Stack direction="row" spacing={1} mt={1} justifyContent="flex-end">
							<Button variant="contained" size="small" endIcon={<Send />} onClick={handleSendComment}>
								{replyTo ? "Reply" : "Send Note"}
							</Button>
						</Stack>
					</Box>
				</Stack>
			</Box>
		</Box>
	);
}

function CommentItem({ comment, showAvt=true, showName=true, onDelete, onReply, parentId = null,handleOpenFile }) {
	// console.log("gvhsbnklajcbhvjk", comment)
	return (
		<Box maxWidth={"80%"} alignSelf={showAvt ? "flex-start" : "flex-end"}>
			<Stack direction="row" spacing={2} width="fit-content">
				{showAvt && <Avatar>{(comment?.name && comment?.name[0]) || comment?.sender_id[0]}</Avatar>}
				<Box flex={1} backgroundColor={showAvt ? "#e0e0e0" : "#c8e6c9"} borderRadius={2} p={1} >
					{showName &&<Typography variant="subtitle2" sx={{ fontWeight: "600",  padding: "3px 5px", width: 'max-content'}}>{comment?.name || comment.sender_id}</Typography>}
					<Box sx={{ whiteSpace: "pre-line", backgroundColor: showAvt ? "#faf8f8ff" : "#def3dfff", padding: "3px 5px", borderRadius: 1 }}>
						<Stack display="flex" flexDirection="row" mb={1} >
							{comment?.attachments && comment?.attachments.length > 0 && comment?.attachments.map((file, idx) => (
								<Box
									onClick={()=>handleOpenFile(file)}
									sx={{...wrapperStyle, backgroundColor: showAvt ? "#ddddddff" : "#c4f3c7ff",borderRadius: 1, margin: "5px" }} key={idx}
								>
									{/* <ImageIcon color="success" sx={{ fontSize: 50 }} /> */}
									{file && getFileIcons(file?.name.split('.').pop())}
									<CommonTooltip title={file.name}/>
								</Box>))}
						</Stack>
						<Typography variant="body2" >
							{comment.message}
						</Typography>
					</Box>
					<Box display={"flex"} justifyContent={"flex-end"} fontSize="10px" paddingTop="5px">{formatMessageTime(comment?.created_at)}</Box>
				</Box>
			</Stack>
		</Box>
	);
}
